namespace GeniuzPOS.Member {
    export class MbReportSaleByDateColumns {
        static columnsKey = 'Member.MbReportSaleByDate';
    }
}
